document.addEventListener('DOMContentLoaded', () => {
  const main = new Main();
});

class Main {
  constructor() {

    this.productList = document.querySelector('.c-pickup .product-list');
    this.productCards = document.querySelectorAll('.c-pickup .product-list .product-card');
    this._observers = [];
    this._init();
  }

  set observers(val) {
    this._observers.push(val);
  }

  get observers() {
    return this._observers;
  }

  _init() {
    if (this.productList) {
      this.productList.classList.add('appear', 'serials', 'up');
      this.productCards.forEach(card => {
        card.classList.add('item');
      });
    }
    this._scrollInit();
  }

  // inviewのトグル appearのアニメーションなど
  _inviewAnimation(el, inview) {
    if (inview) {
      el.classList.add('inview');
    } else {
      el.classList.remove('inview');
    }
  }


  _destroyObservers() {
    this.observers.forEach(ob => {
      ob.destroy();
    });
  }

  destroy() {
    this._destroyObservers();
  }

  _scrollInit() {
    ;
    // appearのアニメーション(appearの子要素)
    this.observers = new ScrollObserver(
      '.appear',
      this._inviewAnimation.bind(this),
      { rootMargin: '0px 0px -40% 0px' }
    );

  }
}
